module.exports = __webpack_public_path__ + "static/po-1f75ca34b150cc71d7b4190dbf572041.svg";